var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIntegrations(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1871_8999)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 11.9556C2 8.47078 2 6.7284 2.67818 5.39739C3.27473 4.22661 4.22661 3.27473 5.39739 2.67818C6.7284 2 8.47078 2 11.9556 2H20.0444C23.5292 2 25.2716 2 26.6026 2.67818C27.7734 3.27473 28.7253 4.22661 29.3218 5.39739C30 6.7284 30 8.47078 30 11.9556V20.0444C30 23.5292 30 25.2716 29.3218 26.6026C28.7253 27.7734 27.7734 28.7253 26.6026 29.3218C25.2716 30 23.5292 30 20.0444 30H11.9556C8.47078 30 6.7284 30 5.39739 29.3218C4.22661 28.7253 3.27473 27.7734 2.67818 26.6026C2 25.2716 2 23.5292 2 20.0444V11.9556Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0019 12.4509L12.541 6.34322C12.6559 6.22622 12.7881 6.14948 12.9203 6.0979C11.8998 6.43379 11.4315 7.57986 11.4315 7.57986L5.10895 18.7348C5.01999 19.0845 4.99528 19.4003 5.0064 19.6783H11.9072L16.0019 12.4509Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.002 12.4509L20.0967 19.6783H26.9975C27.0086 19.4003 26.9839 19.0845 26.8949 18.7348L20.5724 7.57986C20.5724 7.57986 20.1029 6.43379 19.0835 6.0979C19.2145 6.14948 19.3479 6.22622 19.4628 6.34322L16.002 12.4509Z",
    fill: "#FBBC05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0019 12.4512L19.4628 6.34346C19.3479 6.22646 19.2144 6.14973 19.0835 6.09815C18.9327 6.04908 18.7709 6.01637 18.5954 6.00757H18.4125H13.5913H13.4084C13.2342 6.01512 13.0711 6.04783 12.9203 6.09815C12.7894 6.14973 12.6559 6.22646 12.541 6.34346L16.0019 12.4512Z",
    fill: "#188038"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9082 19.6782L8.48687 25.7168C8.48687 25.7168 8.3732 25.6614 8.21875 25.5469C8.70434 25.9206 9.17633 25.9998 9.17633 25.9998H22.6134C23.3547 25.9998 23.5092 25.7168 23.5092 25.7168C23.5116 25.7155 23.5129 25.7142 23.5153 25.713L20.0965 19.6782H11.9082Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9086 19.6782H5.00781C5.04241 20.4985 5.39826 20.9778 5.39826 20.9778L5.65773 21.4281C5.67627 21.4546 5.68739 21.4697 5.68739 21.4697L6.25205 22.461L7.51976 24.6676C7.55683 24.7569 7.60008 24.8386 7.6458 24.9166C7.66309 24.9431 7.67916 24.972 7.69769 24.9972C7.70263 25.0047 7.70757 25.0123 7.71252 25.0198C7.86944 25.2412 8.04489 25.4123 8.22034 25.5469C8.37479 25.6627 8.48847 25.7168 8.48847 25.7168L11.9086 19.6782Z",
    fill: "#1967D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0977 19.6782H26.9984C26.9638 20.4985 26.608 20.9778 26.608 20.9778L26.3485 21.4281C26.33 21.4546 26.3188 21.4697 26.3188 21.4697L25.7542 22.461L24.4865 24.6676C24.4494 24.7569 24.4062 24.8386 24.3604 24.9166C24.3431 24.9431 24.3271 24.972 24.3085 24.9972C24.3036 25.0047 24.2987 25.0123 24.2937 25.0198C24.1368 25.2412 23.9613 25.4123 23.7859 25.5469C23.6314 25.6627 23.5178 25.7168 23.5178 25.7168L20.0977 19.6782Z",
    fill: "#EA4335"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1871_8999",
    x: -2,
    y: -1,
    width: 36,
    height: 36,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1871_8999"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1871_8999",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntegrations);
export default __webpack_public_path__ + "static/media/Integrations.e03db8506573206480035c9da894b3f3.svg";
export { ForwardRef as ReactComponent };